module.exports = __webpack_public_path__ + "img/money (3).91d0cdd6.svg";